(function() {
    'use strict';

    angular
        .module('vobeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('translation', {
            parent: 'entity',
            url: '/translation?page&sort&search&publicSitePartRelationshipId&propertyId',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_TRANSLATOR'],
                pageTitle: 'vobeApp.publicSitePartKey.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/translations/public-site-translation.html',
                    controller: 'PublicSiteTranslationPartController',
                    controllerAs: 'vm'
                },
                'header@': {}
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
            	sitePart : function($transition$, PublicSitePartRelationship){
            	    'ngInject';
            		return PublicSitePartRelationship.get({id :$transition$.params().publicSitePartRelationshipId}).$promise;
            	},
            	siteLanguages : ['PublicSiteLanguages', function(PublicSiteLanguages){
            		return PublicSiteLanguages.get().$promise;
            	}],
            	translations : function(PublicSiteTranslationPart,sitePart){
            	    'ngInject';
            		return PublicSiteTranslationPart.get({partName : sitePart.publicSitePartName, siteName : sitePart.publicSiteName}).$promise;
            	},
                pagingParams: function ($transition$, PaginationUtil) {
            	    'ngInject';
                    return {
                        page: PaginationUtil.parsePage($transition$.params().page),
                        sort: $transition$.params().sort,
                        predicate: PaginationUtil.parsePredicate($transition$.params().sort),
                        ascending: PaginationUtil.parseAscending($transition$.params().sort),
                        publicSitePartRelationshipId: $transition$.params().publicSitePartRelationshipId
                    };
                },
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('publicSitePartKey');
                    //$translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('translation-browse-property', {
            parent: 'entity',
            url: '/translation/browseProperty?publicSitePartRelationshipId&propertyId',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_TRANSLATOR'],
                pageTitle: 'vobeApp.publicSitePartKey.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/translations/public-site-browse-property.html',
                    controller: 'PublicSiteBrowsePropertyController',
                    controllerAs: 'vm'
                },
                'header@': {}
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('publicSitePartKey');
                    //$translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('translation-browse-part', {
            parent: 'entity',
            url: '/translation/browsePart?page&sort&search&publicSitePartRelationshipId&propertyId',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_TRANSLATOR'],
                pageTitle: 'vobeApp.publicSitePartRelationship.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/public-site-part-relationship/public-site-part-relationships.html',
                    controller: 'PublicSitePartRelationshipController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: function ($transition$, PaginationUtil) {
                    'ngInject';
                    return {
                        page: PaginationUtil.parsePage($transition$.params().page),
                        sort: $transition$.params().sort,
                        predicate: PaginationUtil.parsePredicate($transition$.params().sort),
                        ascending: PaginationUtil.parseAscending($transition$.params().sort),
                        search: $transition$.params().search
                    };
                },
                translatePartialLoader: function ($translate, $translatePartialLoader) {
                    'ngInject';
                    $translatePartialLoader.addPart('publicSitePartRelationship');
                    //$translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }
            }
        })
        .state('translation.property', {
            url: '/property',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_TRANSLATOR'],
                pageTitle: 'vobeApp.publicSitePartKey.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/translations/public-site-translation-property.html',
                    controller: 'PublicSiteTranslationPropertyPartController',
                    controllerAs: 'vm'
                },
                'header@': {}
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
            	sitePart : function($transition$,PublicSitePartRelationship){
            	    'ngInject';
            		return PublicSitePartRelationship.get({id :$transition$.params().publicSitePartRelationshipId}).$promise;
            	},
            	siteLanguages : ['PublicSiteLanguages', function(PublicSiteLanguages){
            		return PublicSiteLanguages.get().$promise;
            	}],
                currentProperty: function($transition$, Property) {
            	    'ngInject';
                    return Property.get({id : $transition$.params().propertyId}).$promise;
                },
            	translations : function(PublicSiteTranslationPart,sitePart){
            	    'ngInject';
            		return PublicSiteTranslationPart.get({partName : sitePart.publicSitePartName, siteName : sitePart.publicSiteName}).$promise;
            	},
            	hotelTranslations : function(PublicSiteTranslationPropertyPart,sitePart,currentProperty){
            	    'ngInject';
            		return PublicSiteTranslationPropertyPart.get({hotelId : currentProperty.hotelId ,partName : sitePart.publicSitePartName, siteName : sitePart.publicSiteName}).$promise;
            	},
                pagingParams: function ($transition$, PaginationUtil) {
            	    'ngInject';
                    return {
                        page: PaginationUtil.parsePage($transition$.params().page),
                        sort: $transition$.params().sort,
                        predicate: PaginationUtil.parsePredicate($transition$.params().sort),
                        ascending: PaginationUtil.parseAscending($transition$.params().sort),
                        publicSitePartRelationshipId: $transition$.params().publicSitePartRelationshipId
                    };
                },
                translatePartialLoader: function ($translate, $translatePartialLoader, sitePart) {
            	    'ngInject';
                    $translatePartialLoader.addPart('publicSitePartKey');
                    $translatePartialLoader.addPart(sitePart.publicSitePartName);
                    //$translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }
            }
        });
    };

})();
